


















































import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import ImportSummaryTable from '@/components/importsummary/ImportSummaryTable.vue';
import { Cycle, CycleResource } from '@/api/cycles';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    ImportSummaryTable,
  },
})
export default class ImportSummary extends Vue {
    headerItems: any = [{
      text: 'Rewards Processing',
      disabled: false,
      link: false,
    },
    {
      text: 'Import Summary',
      disabled: true,
    }];

    fiId!: string;

    loading: boolean = true;

    selectedCycle: Cycle | null = null;

    selectedCycleId: number | null = null;

    cycles: Cycle[] = [];

    @Watch('fiId')
    onFiChange() {
      this.loading = true;
      this.cycles = [];
      this.selectedCycle = null;
      this.selectedCycleId = null;
      this.loadCycles();
    }

    @Watch('selectedCycleId')
    onCycleChange() {
      this.selectedCycle = this.cycles.filter((cycle: Cycle) => this.selectedCycleId === cycle.id)[0];
    }

    @Inject('CycleResource')
    cycleResource!: CycleResource;

    mounted() {
      this.loading = true;
      this.loadCycles();
    }

    loadCycles() {
      this.cycleResource.getAllCycles(this.fiId).then((cycles: Cycle[]) => {
        this.cycles = cycles;
        this.selectedCycle = cycles[0];
        this.selectedCycleId = this.selectedCycle.id;
        this.loading = false;
      });
    }
}
